var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 40V48H84V40H68ZM60 66.44C63.84 69.28 68.84 73.04 72.8 76C74.4 73.88 76 71.72 77.6 69.6C73.64 66.64 68.64 62.88 64.8 60C63.2 62.16 61.6 64.32 60 66.44ZM77.6 18.4C76 16.28 74.4 14.12 72.8 12C68.84 14.96 63.84 18.72 60 21.6C61.6 23.72 63.2 25.88 64.8 28C68.64 25.12 73.64 21.4 77.6 18.4ZM12 32C7.6 32 4 35.6 4 40V48C4 52.4 7.6 56 12 56H16V72H24V56H28L48 68V20L28 32H12ZM58 44C58 38.68 55.68 33.88 52 30.6V57.36C55.68 54.12 58 49.32 58 44Z",
    fill: "#1B51A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/digital-marketing.f1562b05d7af950d8d22271612a21f81.svg";
export { ForwardRef as ReactComponent };